import HttpResponse from "../../../../../utils/http/http.response";

export enum CargoCompanyAddressFetchInitDataResponseType {
  HOTEL = "HOTEL",
  STATION = "STATION",
  MEETING_POINT = "MEETING_POINT",
}

export type CargoCompanyAddressFetchInitDataResponseItem = {
  lat: number;
  lon: number;
  country: string | null;
  town: string | null;
  zipCode: string | null;
  street: string | null;
  houseNo: string | null;
  apartment: string | null;
  description: string | null;
  type: CargoCompanyAddressFetchInitDataResponseType;
};

type CargoCompanyAddressFetchInitDataResponse =
  HttpResponse<CargoCompanyAddressFetchInitDataResponseItem>;

export default CargoCompanyAddressFetchInitDataResponse;
